import { Box } from '@mui/material';

import { FHSkeletonLoader } from '../../../components/base';
import { FORTA_WHITE } from '../../../utils/colors';

interface CardLoaderProps {
  sx?: any;
}

function CardLoader({ sx = {} }: CardLoaderProps) {
  return (
    <Box sx={{ p: 2.5, backgroundColor: FORTA_WHITE, borderRadius: '8px', mb: 1, ...sx }}>
      <FHSkeletonLoader width="120px" />
      <Box sx={{ display: 'flex', mt: 1 }}>
        <FHSkeletonLoader
          width="70px"
          rowCount={3}
          containerStyles={{ display: 'flex', mt: 1.5 }}
          sx={{ mr: 1 }}
        />
      </Box>
    </Box>
  );
}

export default CardLoader;
